import React from "react";
import PropTypes from "prop-types";

const ProductPurchaseDetails = ({ image, title, details }) => {
  return (
    <div className="productPurchase__details">
      <div className="productPurchase__details--image">
        <img src={image} alt={title} />
      </div>
      <div className="productPurchase__details--content">
        <h3 className="productPurchase__details--title">{title}</h3>
        <div className="productPurchase__details--list">
          {details.map(({ label, value }, index) => (
            <div key={index} className="productPurchase__details--item">
              <span className="productPurchase__details--label">{label}</span>
              <span className="productPurchase__details--value">{value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

ProductPurchaseDetails.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ProductPurchaseDetails;
